import { ReportOfferReason } from 'logic/api-models/report-offer';

export const REPORT_OFFER_FORM_NAME = 'report-offer-form';

export type ReportOfferFormValues = {
  reason?: ReportOfferReason;
};

export enum ReportOfferFormFields {
  Reason = 'reason',
}
